import Vue from "vue";
import App from "./App.vue";

import axios from 'axios';
import VueAxios from 'vue-axios';
import Clipboard from 'v-clipboard'
import vueDebounce from 'vue-debounce'
import VueDragDrop from 'vue-drag-drop'
import VueRecord from '@/components/audio/index'

import router from "@/router";
import store from "@/store";

import i18n from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { BPM_POLLING_INTERVAL } from '@/constants'

Vue.config.productionTip = false;

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(Clipboard)
Vue.use(vueDebounce, { defaultTime: BPM_POLLING_INTERVAL })
Vue.use(VueRecord)
Vue.use(VueDragDrop)

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
